import { css, type Theme } from "@emotion/react";

export const listItem = (theme: Theme) => css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: ${theme.text.body};
  font-size: 1rem;
  max-width: 14rem;

  :hover {
    color: ${theme.success.textBase};
    text-decoration: underline;
    cursor: pointer;
  }
`;
